import { ChangeDetectorRef, Component, ElementRef, Injector, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Message } from 'primeng/api';
import { InteractiveHelpService } from '../../core/interactive-help/interactive-help.service';
import { ChatMessage } from '../../core/interactive-help/models/message';
import { MessageOption } from '../../core/interactive-help/models/message-option';
import { TransactionResult } from '../../core/services/interfaces/transaction-result';
import { NotificationService } from '../../core/services/notification/notification.service';
import { Alert } from './alert.model';

@Component({
  selector: 'app-quick-panel',
  templateUrl: './quick-panel.component.html',
  styleUrls: ['./quick-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppQuickPanelComponent implements OnInit {
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  private interactiveHelpService: InteractiveHelpService
  
  public date: Date;
  public alerts: Array<Alert> = [];

  public session = [];
  public writing = false;
  public messages: Array<MessageOption> = [];

  constructor(
    private notificationService: NotificationService,
    private injector: Injector
  ) {
    this.date = new Date();

    if (window["useInteractiveHelp"] == true) {
      this.interactiveHelpService = <InteractiveHelpService>this.injector.get(InteractiveHelpService);
      this.callService();
    }

   
  }

  ngOnInit() {
    this.notificationService.alerts.subscribe(alerts => {
      this.alerts = alerts;
    });
  }

  callService(): void {
    let clientId = window["loginType"] == 1 ? window["configuration"].adalConfiguration.clientId : window["configuration"].applicationId;
 
    if (clientId) {
      this.interactiveHelpService.getMessages(clientId).subscribe(
        {
          next: (result: TransactionResult<ChatMessage[]>) => {
            if (result.success) {
              if (result.data.length > 0) {
                this.messages = result.data[0].data;
                this.session.push(this.formartMsjSession('bot', this.getNextMsg('Inicio')));
              }
            }
          }
        }
      );
    }
  }


  public deleteAllAlert() {
    this.notificationService.alerts.next([]);
  }

  public updateMessages() {
    this.notificationService.alerts.next(this.alerts);
  }

  getNextMsg(trigger: string) {
    let msj = this.messages.find((msj) => msj.trigger == trigger);

    return msj;
  }

  restart(): void {
    this.session = [];
    this.session.push(
      this.formartMsjSession('bot', this.getNextMsg('Inicio'))
    );
  }

  refresh(): void {
    this.session = [];
    this.restart();
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  onOptionSelected(option: any) {
    this.writing = true;
    setTimeout(() => {
      this.session.push(this.formartMsjSession('user', { response: option }));
      this.session.push(this.formartMsjSession('bot', this.getNextMsg(option)));
      this.writing = false;
    }, 500);
  }

  formartMsjSession(autor, msg) {
    return {
      autor,
      ...msg,
    };
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }
}
